import { useTheme } from "@mui/material/styles";

interface CheckedIconProps {
  square?: boolean;
}

function CheckedIcon({ square = false }: CheckedIconProps) {
  const { palette } = useTheme();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {square ? (
        <rect width="24" height="24" rx="8" fill="currentColor" />
      ) : (
        <circle cx="12" cy="12" r="12" fill="currentColor" />
      )}
      <path
        d="M7 12.8571L10.5 16L17 8"
        stroke={palette.common.white}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CheckedIcon;
